import { landingImages, LandingSvg } from 'assets';

export const practiceFeatures = [
    {
        id: "automated-billing",
        title: "Completely Automated Billing Suite",
        text: "Take billing off your team’s plate with automation built for ABA workflows." +
            " TherapyLake helps you submit cleaner claims faster, reduce rejections with built-in guardrails, and stay on top of payments without manual back-and-forth",
        bullets: [
            "Automated claim submissions with built-in checks to prevent common rejections",
            "ERAs + payment workflows to reduce manual posting and follow-up",
            "Eligibility checks to catch issues before services are delivered",
            "Guardrails that help standardize billing accuracy across the team",
        ],

        BadgeIcon: LandingSvg.ReceiptItemSvg,
        badgeLabel: 'AUTOMATE REVENUE',
        imageSmall: landingImages.completelyAutomatedImgSmall,
        image:  landingImages.completelyAutomatedImg,
    },
    {
        id: "smart-scheduling",
        title: "Smart Scheduling & Staff Matching",
        text: "Keep your schedule clean, compliant, and easy to manage at scale." +
            " TherapyLake makes it simple to build recurring schedules, prevent conflicts, and match the right staff to the right sessions based on the rules that matter",
        bullets: [
            "Visual indicators to highlight overlapping availability (staff + client)",
            "Staff matching based on smart algorithms",
            "Recurring appointments that align with authorization dates and schedules",
            "Fast appointment changes: schedule, edit, reschedule, and cancel in seconds",
        ],
        BadgeIcon: LandingSvg.Calendar2Svg,
        badgeLabel: 'SCHEDULE WITH CONFIDENCE',
        imageSmall: landingImages.smartSchedulingImgSmall,
        image:  landingImages.smartSchedulingImg,
    },
    {
        id: "timesheets",
        title: "Timesheets + Overtime Calculations Built In",
        text: "We know ABA Payroll is unique. Payroll shouldn’t require stitching together time from multiple places." +
            " TherapyLake turns completed work into payroll-ready reporting and calculates overtime consistently using rules you define",
        bullets: [
            "Payroll reporting suite built from operational activity (not manual entry)",
            "Daily, weekly, time-and-a-half, and double overtime calculations",
            "Configurable pay rules to match how your organization pays staff",
            "Exportable outputs for payroll processing when you need it",
        ],

        BadgeIcon: LandingSvg.MathSvg,
        badgeLabel: 'PAYROLL‑READY',
        imageSmall: landingImages.payrollReadyImgSmall,
        image:  landingImages.payrollReadyImg,
    },
    {
        id: "custom-reporting",
        title: "Custom Reporting & Interactive KPIs",
        text: "Give leadership instant visibility without relying on spreadsheets." +
            " TherapyLake dashboards help you monitor performance across operations and revenue so you can spot issues early and make faster decisions",
        bullets: [
            "Interactive KPIs for scheduling, staffing, payroll, and revenue workflows",
            "Drill into trends by location, service type, staff, and time period",
            "Quickly identify bottlenecks (capacity, authorizations, billing issues)",
            "Report outputs that are easy to share internally",
        ],
        BadgeIcon: LandingSvg.CardEditSvg,
        badgeLabel: 'SEE THE BUSINESS',
        imageSmall: landingImages.customReportingImgSmall,
        image:  landingImages.customReportingImg,
    },
    {
        id: "mobile-app",
        title: "Mobile App Functionality for Teams on the Move",
        text: "Field teams and managers don’t live at a desk. TherapyLake provides mobile access to key practice workflows so your team can stay responsive wherever the day takes them",
        bullets: [
            "Access key scheduling and operational workflows on mobile",
            "Keep staff aligned with day-of changes and updates",
            "Support consistent execution across clinic, home, and school settings",
            "Computer, phone, tablet, Apple and Android",
        ],
        BadgeIcon: LandingSvg.MobileSvg,
        badgeLabel: 'WORK FROM ANYWHERE',
        imageSmall: landingImages.mobileAppFunctionalityImgSmall,
        image:  landingImages.mobileAppFunctionalityImg,
    },
    {
        id: "one-login",
        title: "One Login. One Platform. No “Stitched‑Together” Systems",
        text: "A lot of platforms claim “all‑in‑one,” but they’re really separate tools bundled together—meaning separate logins and broken workflows. " +
            "TherapyLake is built as one platform, with integrations where they actually help",
        bullets: [
            "One login across TherapyLake (no switching between disconnected modules)",
            "Clearinghouse integrations (e.g., Office Ally) to support claims workflows",
            "Calendar sync with tools like Google Calendar",
            "Payroll exports to connect with your payroll provider",
        ],
        BadgeIcon: LandingSvg.ZapSvg,
        badgeLabel: 'TRULY ALL‑IN‑ONE',
        imageSmall: landingImages.onePlatformImgSmall,
        image:  landingImages.onePlatformImg,
    },
    {
        id: "hipaa-security",
        title: "HIPAA‑Aligned Security & Auditability",
        text: "Protect client and staff data with security controls designed for healthcare operations. TherapyLake supports structured access, auditability, and encryption to help you scale safely",
        bullets: [
            "Role‑based access control (RBAC)",
            "Audit logs for accountability and compliance support",
            "Encryption in transit and at rest",
            "Secure backups for continuity and recovery"
        ],
        BadgeIcon: LandingSvg.SecuritySafeSvg,
        badgeLabel: 'SECURE BY DESIGN',
        imageSmall: landingImages.alignedSecurityImgSmall,
        image:  landingImages.alignedSecurityImg,
    }
];
